
<template>
  <div class="ApproveSetting">
    <!-- 新增/修改门禁弹窗 -->
    <el-dialog
      class="dialog816"
      title="审批信息"
      :visible.sync="isDialogShow"
      :close-on-click-modal="false"
    >
      <el-form
        :model="approveForm"
        :rules="rules"
        ref="approveForm"
        label-width="120px"
        class="contactsForm"
      >
        <el-row>
          <el-col :span="24">
            <el-row>
              <div class="time-box">
                <div
                  class="item"
                  v-for="(item, index) in approveForm.typeRelList"
                  :key="index"
                >
                  <div class="left">
                    <el-col :span="8">
                      <el-form-item
                        :label="'合作单位分类' + (index + 1) + '：'"
                      >
                        <el-select
                          v-model="item.topId"
                          placeholder="请选择一级分类"
                          filterable
                          @change="firstSupplierTypeChange(item.topId, index)"
                        >
                          <el-option
                            :label="supplier.typeValue"
                            :value="supplier.id"
                            v-for="supplier in firstSupplierTypeList"
                            :key="supplier.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item label="" label-width="80px">
                        <el-select
                          v-model="item.secondId"
                          filterable
                          default-first-option
                          placeholder="请选择二级分类"
                          @change="
                            secondSupplierTypeChange(item.secondId, index)
                          "
                          
                        >
                          <el-option
                            :label="supplier.typeValue"
                            :value="supplier.id"
                            v-for="supplier in secondSupplierTypeList[index]"
                            :key="supplier.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="8">
                      <el-form-item
                        class="noMarginBottom"
                        label
                        label-width="40px"
                      >
                        <el-select
                          v-model="item.thirdId"
                          filterable
                          default-first-option
                          placeholder="请选择三级分类"
                          
                        >
                          <el-option
                            :label="supplier.typeValue"
                            :value="supplier.id"
                            v-for="supplier in thirdSupplierTypeList[index]"
                            :key="supplier.id"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </div>
                  <div class="right" >
                    <el-button
                      v-if="index == 0"
                      @click="addDevPlatTypeList"
                      size="small"
                      icon="el-icon-circle-plus"
                    ></el-button>
                    <el-button
                      v-if="index != 0"
                      @click="delDevPlatTypeList(index)"
                      size="small"
                      icon="el-icon-remove"
                    ></el-button>
                  </div>
                  <!-- <div class="right del" @click="delDevPlatTypeList(index)">删除</div> -->
                </div>
              </div>
            </el-row>
          </el-col>
        </el-row>
        <el-row >
          <el-col :span="9">
            <el-form-item label="审批流：" prop="Approvetype">
              <el-select
                v-model="approveForm.approveTemplateId"
                filterable
                default-first-option
                placeholder="请选择"
              >
                <el-option label="劳务" value="1"></el-option>
                <el-option label="机械" value="3"></el-option>
                <el-option label="材料" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="isDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="submitBtn(1)">保 存</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getSupplierTypeList, //获取供应商一级类别列表接口
  getSuppliersubTypeList, //查询子类别列表接口
  updateSupplierStatus, //更新供应商审批启用状态
} from "../../../services/supplierMagServices";
export default {
  name: "ApproveSetting",
  data() {
    return {
      isDialogShow: false,
      //审批信息
      approveForm: {
        isTop: 0, //默认不置顶
        supplierId: "", //供应商id
        approveTemplateId:"" ,  //审批流模板id
        topType: "", //供应商类型，甲方 乙方
        typeRelList: [
          {
            topId: "", //一级分类
            secondId: "", //二级分类
            thirdId: "", //三级级分类
          },
        ], //合作单位分类数组
      },
      supplierId: "", //存放供应商id
      firstSupplierTypeList: [], //一级供应商分类列表
      secondSupplierTypeList: [], //二级供应商分类列表
      thirdSupplierTypeList: [], //三级供应商分类列表
      rules: {
        topId: [
          { required: true, message: "请选择合作单位分类", trigger: "change" },
        ],
        Approvetype: [
          { required: true, message: "请选择审批类型", trigger: "change" },
        ],
      },
    };
  },
  methods: {
    showPwdDialog(supplierId) {
      this.approveForm.supplierId = supplierId;
      this.isDialogShow = true;
      this.getSupplierTypeList(); //获取一级分类下拉列表
      this.getSupplierDetail(supplierId);
    },
    //获取一条供应商信息
    getSupplierDetail(supplierId) {
      if (this.RouteParam) {
        this.approveForm.typeRelList = [];
        let param = {};
        param.supplierId = supplierId;
        getSupplierADetailService(param)
          .then((res) => {
            if (res.code == 10000000) {
              this.ruleForm = res.data;
               this.approveForm.approveTemplateId=res.data.approveTemplateId
              if (null == res.data.typeRelList) {
                this.approveForm.typeRelList = [];
                this.approveForm.typeRelList.push({
                  secondId: "",
                  thirdId: "",
                  topId: "",
                });
              } else {
                this.approveForm.typeRelList = res.data.typeRelList;
                let len = res.data.typeRelList.length;
                if (len > 0) {
                  for (let i = 0; i < len; i++) {
                    if (this.approveForm.typeRelList[i].topId) {
                      let topId = this.approveForm.typeRelList[i].topId;
                      this.getsubSupplierTypeList(topId, i, 2);
                    }
                    if (this.approveForm.typeRelList[i].secondId) {
                      let secondId = this.approveForm.typeRelList[i].secondId;
                      this.getsubSupplierTypeList(secondId, i, 3);
                    }
                  }
                }
              }
            } else if (res.code >= 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          })
          .catch((error) => {
            this.$alert(error, "提示", {
              confirmButtonText: "确定",
            });
          });
      }
    },
    //获取一级供应商分类列表
    getSupplierTypeList() {
      let reqParam = {
        pageIndex: "1",
        pageSize: "50",
      };
      getSupplierTypeList().then(
        (res) => {
          if (res.code == 10000000) {
            this.firstSupplierTypeList = res.data;
            // this.getSupplierDetail(this.supplierId);
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        },
        (err) => {
          this.$message.error("系统异常");
        }
      );
    },
    //获取下级供应商分类列表
    getsubSupplierTypeList(val, index, typeLevel) {
      let param = {};
      param.supplierTypeId = val;
      getSuppliersubTypeList(param)
        .then((res) => {
          if (res.code == 10000000) {
            if (typeLevel == 2) {
              this.secondSupplierTypeList[index] = res.data;
              this.$forceUpdate();
              if (null != this.approveForm.secondId) {
                this.approveForm.typeRelList[index].secondId =
                  this.approveForm.typeRelList[index].secondId;
              }
            } else {
              this.thirdSupplierTypeList[index] = res.data;
              this.$forceUpdate();
              if (null != this.approveForm.typeRelList[index].thirdId) {
                this.approveForm.typeRelList[index].thirdId =
                  this.approveForm.typeRelList[index].thirdId;
              }
            }
          } else {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {
          this.$message.error("系统异常");
        });
    },
    //选择完一级分类获取二级分类
    firstSupplierTypeChange(val, index) {
      // this.secondSupplierTypeList[index] = [];
      // this.thirdSupplierTypeList[index] = [];
      this.approveForm.typeRelList[index].secondId = "";
      this.approveForm.typeRelList[index].thirdId = "";
      this.getsubSupplierTypeList(val, index, 2);
    },
    //选择完二级分类获取三级分类
    secondSupplierTypeChange(val, index) {
      // this.thirdSupplierTypeList[index] = [];
      this.approveForm.typeRelList[index].thirdId = "";
      this.getsubSupplierTypeList(val, index, 3);
    },
    /**
     * 新增a一行数据分类
     */
    addDevPlatTypeList() {
      let len = this.approveForm.typeRelList.length;
      if (len == 4) {
        this.$alert("最多添加四条分类信息", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      for (let i = 0; i < len; i++) {
        let val = this.approveForm.typeRelList[i];
        if (val.topId == "") {
          this.$alert("有未选择的一级分类", "提示", {
            confirmButtonText: "确定",
          });
          return;
        }
        // if (val.secondId == "") {
        //   this.$alert("有未选择的二级分类", "提示", {
        //     confirmButtonText: "确定"
        //   });
        //   return;
        // }
        // if (val.thirdId == "") {
        //   this.$alert("有未选择的三级分类", "提示", {
        //     confirmButtonText: "确定"
        //   });
        //   return;
        // }
      }

      this.approveForm.typeRelList.push({
        topId: "",
        secondId: "",
        thirdId: "",
      });
    },
    /**
     * 删除一条数据分类
     */
    delDevPlatTypeList(index) {
      this.approveForm.typeRelList.splice(index, 1);
    },
    //提交
    submitBtn(val) {
      let params = {
        ...this.approveForm,
        approveStatus: val,
        // id: this.supplierId,
        topType: this.approveForm.topType,
      };
      let msg = "确认通过吗？";
      if (val == 0) {
        msg = "确认拒绝该吗？";
      }
      // this.$refs["ruleForm"].validate(valid => {
      //   if (valid) {
      this.$confirm(msg, "提示", {
        confirmButtonText: "确认",
      }).then(() => {
        updateSupplierStatus(params).then((res) => {
          if (res.code == 10000000) {
            this.$message.success("审核完成");
            this.bus.$emit("tabClose", "supplierAApproveDetail");
            this.bus.$emit("navMenuChange", {
              routeId: "supplierAApprove",
            });
          } else {
            this.$message.error(res.msg);
          }
        });
        //   }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.ApproveSetting {
  /deep/.el-dialog {
    /deep/.el-icon-view:before {
      display: none;
    }
    .el-form-item__content {
      width: calc(100% - 50px);

      .el-input {
        width: 100%;
      }
      .el-select {
        width: 100%;
      }
    }
  }
  .time-box {
    //  display: flex;
    // height: 180px;
    overflow-y: auto;
    flex: 1;

    .item {
      display: flex;
      justify-content: flex-start;
      align-items: center;
    }
  }
  .left {
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin-right: 40px;
    width: 90%;
  }

  .right {
    height: 32px;
    line-height: 32px;
    width: 40px;
    text-align: center;
    cursor: pointer;
    margin-bottom: 20px;
  }

  .add {
    background-color: #38b1c9;
    border-radius: 2px;
    color: #ecf5ff;
  }
}
</style>
